Application.Summary = {
    ui: {
        form: '.js-summary',
        back: '.js-summary__back',
        gva: '.js-summary__gva',
        gvaBar: '.js-summary__gva-bar',
        rent: '.js-summary__rent',
        rentBar: '.js-summary__rent-bar',
        sampleBoost: '.js-summary__sample-boost',
        improvement: '.js-summary__improvement',
        timeUnit: '.js-summary__time-unit',
        showYears: '.js-summary__show-years',
        showMonths: '.js-summary__show-months',
    },
    ready: function () {

        var self = this;

        if (!$(this.ui.form).length){
            return;
        }

        this.Email.ready(this);

        // change time units
        $(this.ui.showYears).change(function(e){
            self.recalculate();
        });
        $(this.ui.showMonths).change(function(e){
            self.recalculate();
        });

        // change slider
        $(this.ui.improvement).change(function(e){
            self.recalculate();
        });
        this.recalculate();

        // back
        $(this.ui.back).click(function(){
            self.showLoader();
        });

    },
    recalculate: function () {

        // retrieve data
        var gva = $(this.ui.gva).attr('data-gva');
        var improvement = parseFloat($(this.ui.improvement).val());
        var increasedGva = gva * improvement / 100;

        var rent = parseFloat($(this.ui.rent).attr('data-annual-value'));
        var sampleBoost = parseFloat($(this.ui.sampleBoost).attr('data-annual-value'));

        var isMonthly = $(this.ui.showMonths).is(':checked');
        var ratio = isMonthly ? 12 : 1;

        // GVA
        // area per employee
        var areaPerEmployee = $(this.ui.form).attr('data-area-per-employee');

        // update text value
        var gvaValue = increasedGva / ratio;
        $(this.ui.gva).text(this.formatNumber(isMonthly ? gvaValue / areaPerEmployee : gvaValue));
        // update bar value
        $(this.ui.gvaBar).attr('data-value', increasedGva);

        // sample boost
        $(this.ui.sampleBoost).text(this.formatNumber((isMonthly ? sampleBoost / areaPerEmployee : sampleBoost) / ratio));
        // rent
        var rentValue = rent / ratio;
        $(this.ui.rent).text(this.formatNumber(isMonthly ? rentValue / areaPerEmployee : rentValue));

        // units
        $(this.ui.timeUnit).html(isMonthly ? 'm<sup>2</sup>&nbsp;/&nbsp;month' : 'emp.&nbsp;/&nbsp;year');

        // update bar chart
        this.redrawChart();

    },
    formatNumber: function (n) {

        n = Math.round(n);

        return n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

    },
    redrawChart: function(){

        var $rentBar = $(this.ui.rentBar);
        var rentValue = parseFloat($rentBar.attr('data-value'));
        var $gvaBar = $(this.ui.gvaBar);
        var gvaValue = parseFloat($gvaBar.attr('data-value'));

        if (gvaValue > rentValue){
            $gvaBar.css('width', '100%');
            $rentBar.css('width', (100 * rentValue / gvaValue) + '%');
        }else{
            $rentBar.css('width', '100%');
            $gvaBar.css('width', (100 * gvaValue / rentValue) + '%');
        }

    },
    showLoader: function(){

        $('body').addClass('loading');

    },
    hideLoader: function(){

        $('body').removeClass('loading');

    }
};